import React from 'react'
import { useNotificationStore } from '../../store/notifications'
import { Notification } from './Notification'

/**
 * Notifications component to render and manage a list of notifications.
 *
 * @module notifications/Notifications
 * @description Notifications component to render and manage a list of notifications.
 * @example
 * const notifications = [
 *   { id: '1', type: 'success', message: 'Action successful' },
 *   { id: '2', type: 'error', message: 'An error occurred' }
 * ];
 * return (
 *   <Notifications />
 * );
 *
 * @returns {React.Element} A container that renders the notifications.
 */
export const Notifications = () => {
  const { notifications, dismissNotification } = useNotificationStore()
  let px = 0

  return (
    <div style={{ bottom: '4rem' }}>
      {notifications.map((notification) => {
        px = px + 60
        return (
          <Notification
            key={notification.id}
            notification={notification}
            onDismiss={dismissNotification}
            notifications={notifications}
            px={px}
          />
        )
      })}
    </div>
  )
}
